import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconDividerBlank16(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={16}
            height={16}
            className={customClassName}
            name="IconDividerBlank16"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M3.046 3.007a1 1 0 0 1 1-1h8a1 1 0 0 1 1 1v1.5a.5.5 0 1 0 1 0v-1.5a2 2 0 0 0-2-2h-8a2 2 0 0 0-2 2v1.5a.5.5 0 0 0 1 0zM3 13a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1v-1.5a.5.5 0 0 1 1 0V13a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2v-1.5a.5.5 0 0 1 1 0z"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconDividerBlank16);
